<template lang="pug">
.member-content
  .member-title {{ $t("ui.deposit") }}
  .bank-detail
    .bank-detail-header {{ $t("ui.bank_details") }}
    .bank-detail-body
      .row
        .col-5.col-lg-3.text-capitalize {{ $t("ui.account_name") }}
        .col-1.col-lg-auto : 
        .col-6.col-lg-8 {{ depositChannel == 'MANUAL' ? bankDetail.bank_acc_holder : gatewayDetail[0].bank_acc_holder }}
      .row
        .col-5.col-lg-3.text-capitalize {{ $t("ui.account_number") }}
        .col-1.col-lg-auto : 
        .col-6.col-lg-8 {{ depositChannel == 'MANUAL' ? bankDetail.bank_acc_no : gatewayDetail[0].bank_acc_no }}
      .row
        .col-5.col-lg-3.text-capitalize {{ $t("ui.bank_name") }}
        .col-1.col-lg-auto : 
        .col-6.col-lg-8 {{ depositChannel == 'MANUAL' ? bankDetail.bank_name : gatewayDetail[0].bank_name }}
  .member-form
    form
      .form-field
        .form-label {{ $t("ui.deposit_channel") }}
        .input-group
          select.form-select.form-control(v-model="depositChannel")
            option(v-for="bank in bankList" :value='bank.banking_mode') {{ bank.banking_mode }}
      template(v-if="depositChannel == 'MANUAL'")
        .form-field
          .form-label {{ $t("ui.bank") }}
          .input-group
            select.form-select.form-control#bankinfo(v-model="bankDetail")
              option(v-for="bank in bankInfo" :value='bank') {{ bank.bank_name }}
        .form-field
          .form-label {{ $t("ui.deposit_methods") }}
          .input-group
            select.form-select.form-control(v-model="depositMethod")
              option(value='online') {{ $t("ui.deposit_options.online_banking") }}
              option(value='atm') {{ $t("ui.deposit_options.atm_transfer") }}
              option(value='cash') {{ $t("ui.deposit_options.cash_deposit") }}
      .form-field
        .form-label {{ $t("ui.amount") }}
        .input-group
          input.form-control.amount(
            type='text'
            v-model.trim.lazy="$v.depositAmount.$model"
            :disabled="loading" 
            :placeholder="$t('ui.tooltips.deposit_amount', { 'minbet': minDisplay() })"
          )
        ValidateResult(:value="$v.depositAmount" :name="$t('ui.amount')")            
      .deposit-amount-wrapper
        .row.row-cols-12
          .col
            .select-amount(@click="depositAmount = 10000") 10,000
          .col
            .select-amount(@click="depositAmount = 20000") 20,000
          .col
            .select-amount(@click="depositAmount = 50000") 50,000
          .col
            .select-amount(@click="depositAmount = 100000") 100,000
          .col
            .select-amount(@click="depositAmount = 500000") 500,000
          .col
            .select-amount(@click="depositAmount = 1000000") 1,000,000
      .form-field
        .form-label {{ $t("ui.refno") }}
        .input-group
          input.form-control(
            type='text'
            v-model.trim.lazy="$v.refno.$model"
            :maxLength="$v.refno.$params.maxLength.max"
          )
      //- .form-field
      //-   .form-label {{ $tc("ui.promo", 2) }}
      //-   .input-group
      //-     select.form-select.form-control
      //-       option(value='1' selected='') {{ $t("ui.tooltips.select_promotion") }}
      //-       option(value='2') 100% First Deposit Bonus
      //-       option(value='3') 100% First Deposit Bonus
      .form-field
        .form-label {{ $t("ui.receipt") }}
        .input-group
          .custom-file.w-100
            input#customFile.custom-file-input.d-none(type='file' ref="fileInput" @change="handleFileUpload" @click="openFileInput")
            label.custom-file-label.w-100(for='customFile') {{ selectedFile ? selectedFile.name : $t("ui.choose_file") }}
        .input-feedback {{ $t("ui.tooltips.file_upload") }}
      .btn-form.py-2.py-xl-3
        a(href='javascript:void(0);' @click.stop="onSubmit")
          .btn-submit {{ $t("ui.submit") }}
</template>
  
<script>
import { required, minValue, numeric, maxLength } from 'vuelidate/lib/validators'
  
export default {
  components: {
    ValidateResult: () => import("@/library/ValidateResult")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      depositChannel: "MANUAL",
      depositMethod: "online",
      bankDetail: [],
      gatewayDetail: [],
      depositAmount: null,
      selectedFile: null,
      filename: "",
      refno: "",
      bank: {
        bank_id: "",
        bank_acc_no: "",
        bank_acc_holder: "",
        deposit_method: ""
      }
    }
  },
  validations: {
    depositAmount: {
      required,
      numeric,
      minValue(value) {
        return minValue(this.getMinMaxBet(1))(value);
      }      
    },
    refno: {
      maxLength: maxLength(20)
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    memberBankMode() {
      return this.$store.getters.memberBankMode || { banklist: [] }
    },
    bankList() {
      return this.memberBankMode?.banklist?.filter(item => item.status === true) || []
    },
    bankInfo() {
      return this.memberBankMode?.bankinfo?.filter(item => item.bank_id != 'GATEWAY') || []
    },
    bankSetting() {
      return this.memberBankMode.setting
    },
    gatewayInfo() {
      return this.memberBankMode?.bankinfo?.filter(item => item.bank_id == 'GATEWAY') || []
    }
  },
  watch: {
    depositChannel(newVal, oldVal){
      this.gatewayDetail = this.gatewayInfo.filter(item => item.bank_acc_no == newVal);
    }
  },
  mounted() { 
    this.getMemberBankMode()
    $('input.amount').on('focus', function() {
      const value = $('input.amount')[0].value;
      $('input.amount')[0].type = 'number';
      $('input.amount')[0].value = Number(value.replace(/,/g, ''))
    });

    let vm = this
    $('input.amount').on('blur', function() {
      const value = $('input.amount')[0].value;
      let trimmedString = value.replace(/^0+/, '');
      $('input.amount')[0].type = 'text';
      $('input.amount')[0].value = trimmedString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    });
  },
  methods: {
    getMemberBankMode() {
      if (this.isLoggedIn) {
        this.loading = true;
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberBankMode", { login_id, auth_token }).then(
          res => {
            this.loading = false;
            if (res.success) {
              this.bankDetail = this.bankInfo ? this.bankInfo[0] : "";
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    getMinMaxBet(mode) {
      if(this.bankSetting && this.bankSetting.length > 0) {
        return mode == 1 ? this.bankSetting[1].setting_value : this.bankSetting[3].setting_value;
      }
    },
    minDisplay() { 
      return this.getMinMaxBet(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        if (this.isFileAllowed(file.type)) {
          if(file.size > 2 * 1024 * 1024) {
            this.selectedFile = null
            this.$helpers.handleFeedback('file_upload')
          } else {
            this.selectedFile = file
          }
        } else {
          this.selectedFile = null
          this.$helpers.handleFeedback('unsupported_format')
        }
      } else {
        this.selectedFile = null
      }
    },
    isFileAllowed(fileType) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      return allowedTypes.includes(fileType);
    },
    async onSubmit() {
      if (this.selectedFile === "") {
        this.wbDeposit()
      } else {
        const formData = new FormData()
        formData.append("file", this.selectedFile)
        this.loading = true
        try {
          await this.$http
            .post("https://upload.uploadattachmntmulti.com/upload", formData)
            .then(function(response) {
              this.loading = false
              if (response.ok) {
                if (typeof response.data.file != "undefined") {
                  if (response.data.file.filename) {
                    this.filename = response.data.file.filename;
                  }
                  this.wbDeposit()
                } else {
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.upload_missing"), "info")
                }
              } else {
                this.$helpers.showDialog(this.$t("ui.success"), this.$t("message.upload_cancel"), "info")
              }
            });
        } catch (err) {
          this.loading = false
          if (err.status === 0 && err.data === "") {
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.upload_cancel"), "info");
          } else {
            // console.log(err)
            var message = this.$t("message.disconnect")
            // if(err.data.err) {
            //   message = err.data.err;
            // }
            this.$helpers.showDialog(this.$t("ui.attention"), message, "info")
          }
        }
      }
    },
    setBank(){
      if(this.depositChannel == 'MANUAL') {
        this.bank.bank_id = this.bankDetail.bank_id;
        this.bank.bank_acc_no = this.bankDetail.bank_acc_no;
        this.bank.bank_acc_holder = this.bankDetail.bank_acc_holder;
        this.bank.deposit_method = this.depositMethod
      } else {
        this.bank.bank_id = this.gatewayDetail[0].bank_id;
        this.bank.bank_acc_no = this.gatewayDetail[0].bank_acc_no;
        this.bank.bank_acc_holder = this.gatewayDetail[0].bank_acc_holder;
        this.bank.deposit_method = "online"
      }
    },
    wbDeposit() {
      this.$v.$touch()
      this.setBank()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let login_id = this.accountID
          let auth_token = this.sessionToken
          let amount = this.depositAmount
          let bank_id = this.bank.bank_id
          let bank_acc_no = this.bank.bank_acc_no
          let bank_acc_holder = this.bank.bank_acc_holder
          let ref_no = this.refno
          let attachment_path = this.filename ? "https://img.uploadattachmntmulti.com/" + this.filename : ""
          let deposit_date = this.$moment().format("YYYY-MM-DD HH:mm:ss")
          let deposit_method = this.bank.deposit_method
          this.loading = true
          
          this.$store
            .dispatch("user/wbDeposit", { login_id, auth_token, amount, bank_id, bank_acc_no, bank_acc_holder, ref_no, attachment_path, deposit_date, deposit_method })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                this.$helpers.showDialog(this.$t("ui.success"), this.$t("message.deposit_success"), "success")
                this.$router.push("/statement");
              } else {
                this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error");
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              this.feedback.status = this.$t("error." + response.status)
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error");
            });
        }
      }
    },
    reset() {
      this.loading = false,
      this.depositChannel = "MANUAL",
      this.depositMethod = "online",
      this.bankDetail = [],
      this.gatewayDetail = [],
      this.depositAmount = null,
      this.selectedFile = null,
      this.filename = ""
      this.refno = "",
      this.bank = {
        bank_id: "",
        bank_acc_no: "",
        bank_acc_holder: "",
        deposit_method: ""
      }
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    },
  }
}
</script>